import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import MediaUpload from '../../../../../MediaUpload/MediaUpload'

const FILE_MAX_SIZE = 10000000 // 10MB

const UploadTab = ({ onChange = () => {}, value }) => {
  const { t } = useTranslation(['chat'])
  return (
    <div className="tab-content upload-tab">
      <div>
        <MediaUpload
          labelText={t('chat:manageVoicemail.uploadLabel')}
          mediaTypes={['audio']}
          onUpdate={onChange}
          files={[value]}
          maxSize={FILE_MAX_SIZE}
        />
        <span className="input-desc-label">{t('chat:manageVoicemail.maxSizeTip')}</span>
      </div>
    </div>
  )
}

UploadTab.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.object,
}

export default UploadTab
